export const DEFAULT_VIEWING_DURATION_IN_MINUTES = 30;
export const AVAILABLE_MINUTES_VALUES = {
  ZERO: 0,
  THIRTY: 30,
};

export const BOOK_VIEWING_EVENT_LABEL = 'Book A Viewing - Started';
